import React, { useState } from 'react';
import { Modal, IconButton, Box } from '@mui/material';
import Close from '@mui/icons-material/Close';

import {
  GuideModalContainer,
  GuideModalHeader,
  GuideModalHeaderTitle,
  GuideModalBody,
  GuideSection,
  GuideSectionLabel,
  GuideText,
  GuideDivider,
} from '../../../lesson/groupLesson/GroupLessonStyled';

const TABS = [
  { key: 'overview', label: '이용권이란?' },
  { key: 'fields', label: '등록 항목' },
  { key: 'usage', label: '이용기간·정지' },
  { key: 'refund', label: '환불·양도·주의사항' },
];

const OverviewGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>🎫 이용권이란?</GuideSectionLabel>
      <GuideText>
        예약 없이 자유롭게 출입/이용하는 상품입니다(예: 헬스장 자유이용권).<br />
        수강권과 달리 <strong>담당 강사 배정, 커리큘럼 개념이 없습니다.</strong>
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>⚠️ 흔한 오해</GuideSectionLabel>
      <GuideText>
        "이용구분"을 <strong>기간제가 아니라 횟수제로도 설정할 수 있습니다.</strong><br />
        즉 <strong style={{ color: '#EE753A' }}>"이용권 = 무조건 자유이용"이라고 단정하면 안 됩니다.</strong> 횟수제 이용권도 만들 수 있으며, 이 경우에도 예약·강사배정 개념은 여전히 없습니다.
      </GuideText>
    </GuideSection>
  </>
);

const FieldsGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>➕ 등록 시 입력 항목</GuideSectionLabel>
      <GuideText>
        • <strong>구독상품 여부</strong>(일반/구독제) — 구독제는 이용기간이 <strong>1개월로 고정</strong>됩니다.<br />
        • <strong>이용권명, 판매지점/이용지점</strong> — 다지점 공유 상품 설정, "구매한 지점만 이용" 옵션 지원<br />
        • <strong>운동종목</strong>(복수 선택), <strong>출입설정</strong>(출입문 그룹)
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>⏱️ 이용 설정</GuideSectionLabel>
      <GuideText>
        • <strong>이용구분</strong> — 기간제 또는 횟수제 중 선택<br />
        &nbsp;&nbsp;- 기간제: 이용기간(개월/일) 입력<br />
        &nbsp;&nbsp;- 횟수제: 이용횟수 입력<br />
        • <strong>중지권</strong> — 무제한 / 중지 불가(0) / 직접입력<br />
        • <strong>요일설정, 시간대설정</strong> — 특정 요일·시간대에만 이용 가능하도록 제한 가능
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>💰 가격</GuideSectionLabel>
      <GuideText>
        정가, 할인금액, 최종 결제금액, 판매기간, 할인기간을 설정합니다.
      </GuideText>
    </GuideSection>
  </>
);

const UsageGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>📅 유효기간</GuideSectionLabel>
      <GuideText>
        • 구매(또는 양도) 시점에 시작일과 만료일이 확정되어 저장됩니다.<br />
        • 양도된 경우에는 시작일이 <strong>양도일(오늘)</strong>로 재설정됩니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>⏸️ 정지(홀딩)</GuideSectionLabel>
      <GuideText>
        • <strong>무제한</strong>(값 없음) / <strong>중지 불가</strong>(0) / <strong>직접입력</strong>(N회, N일) 중 하나로 설정됩니다.<br />
        • 정지하면 정지 일수만큼 <strong>만료일이 뒤로 연장</strong>됩니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🔢 하루/주 이용 제한</GuideSectionLabel>
      <GuideText>
        일일·주간 이용횟수 제한을 설정할 수 있습니다. 다만 초과 시 실제로 막히는 방식은 이용 화면(출입/키오스크)에 따라 다를 수 있으니, 적용 여부는 실제 이용 화면에서 확인해보는 것을 권장합니다.
      </GuideText>
    </GuideSection>
  </>
);

const RefundGuide = () => (
  <>
    <GuideSection>
      <GuideSectionLabel>💸 환불</GuideSectionLabel>
      <GuideText>
        환불금액은 <strong>시스템이 자동 계산하지 않고</strong> 관리자가 화면에서 직접 입력합니다. 정확한 잔여가치를 계산한 후 입력해야 합니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>🔄 양도</GuideSectionLabel>
      <GuideText>
        • <strong>사용중(ACTIVE)</strong> 상태만 양도 가능합니다(정지·만료·이미 양도된 건은 불가).<br />
        • 수수료는 관리자가 입력할 수 있으며 양도자 매출로 기록됩니다.<br />
        • <strong style={{ color: '#EE753A' }}>당일 양도에 한해서만</strong> 취소(롤백)할 수 있습니다. 하루만 지나도 되돌릴 수 없습니다.
      </GuideText>
    </GuideSection>

    <GuideDivider />

    <GuideSection>
      <GuideSectionLabel>⚠️ 주의사항</GuideSectionLabel>
      <GuideText>
        • 판매지점과 이용지점을 다르게 설정할 수 있습니다(다지점 공유 상품). "구매한 지점만 이용" 옵션을 켜면 이용지점 목록이 비어 보일 수 있으니 설정 의도를 다시 확인하세요.<br />
        • 중지권 설정에서 <strong>"빈 값(무제한)"과 "0(중지 불가)"은 의미가 다릅니다.</strong> 혼동하지 않도록 주의하세요.
      </GuideText>
    </GuideSection>
  </>
);

const TAB_CONTENT = {
  overview: OverviewGuide,
  fields: FieldsGuide,
  usage: UsageGuide,
  refund: RefundGuide,
};

const PassGuideModal = ({ open, onClose }) => {
  const [activeTab, setActiveTab] = useState('overview');
  const TabContent = TAB_CONTENT[activeTab];

  return (
    <Modal open={open} onClose={onClose} disableScrollLock>
      <GuideModalContainer>
        <GuideModalHeader>
          <GuideModalHeaderTitle>이용권 가이드</GuideModalHeaderTitle>
          <IconButton onClick={onClose} sx={{ color: '#fff', p: '4px' }}>
            <Close />
          </IconButton>
        </GuideModalHeader>

        {/* 탭 */}
        <Box sx={{
          display: 'flex', borderBottom: '1px solid #e0e0e0', flexShrink: 0, backgroundColor: '#fafafa',
        }}>
          {TABS.map(tab => (
            <Box
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              sx={{
                flex: 1, textAlign: 'center', padding: '12px 0', cursor: 'pointer',
                fontSize: '13px', fontWeight: activeTab === tab.key ? 700 : 500,
                fontFamily: 'Pretendard, sans-serif',
                color: activeTab === tab.key ? '#4AB3BC' : '#888',
                borderBottom: activeTab === tab.key ? '2px solid #4AB3BC' : '2px solid transparent',
                transition: 'all 0.15s ease',
                '&:hover': { color: '#4AB3BC', backgroundColor: '#f0f8f8' },
              }}
            >
              {tab.label}
            </Box>
          ))}
        </Box>

        <GuideModalBody>
          <TabContent />
        </GuideModalBody>
      </GuideModalContainer>
    </Modal>
  );
};

export default PassGuideModal;
